<template>
	<div class="relative flex justify-between items-center">
		<!-- Scroll Left Button -->
		<button aria-label="Scroll left" @click="scrollLeft" :class="leftButtonClass">
			<svg class="w-2" viewBox="0 0 9 13" xmlns="http://www.w3.org/2000/svg">
				<path d="M1 1L7 6.5L1 12" stroke-width="1.75" fill="none" />
			</svg>
		</button>

		<!-- Scroll Right Button -->
		<button aria-label="Scroll right" @click="scrollRight" :class="rightButtonClass">
			<svg class="w-2" viewBox="0 0 9 13" xmlns="http://www.w3.org/2000/svg">
				<path d="M1 1L7 6.5L1 12" stroke-width="1.75" fill="none" />
			</svg>
		</button>
	</div>
</template>

<script>
export default {
	props: {
		scrollContainer: {
			type: Object,
			required: true,
		},
		leftButtonClass: {
			type: String,
			default: 'bg-ihh-black/70 px-3 py-3', // Default button class for left button
		},
		rightButtonClass: {
			type: String,
			default: 'bg-ihh-black/70 px-3 py-3', // Default button class for right button
		},
	},
	methods: {
		scrollLeft() {
			if (this.scrollContainer) {
				this.scrollContainer.scrollBy({
					left: -300, // Adjust scroll distance as needed
					behavior: 'smooth',
				})
			}
		},
		scrollRight() {
			if (this.scrollContainer) {
				this.scrollContainer.scrollBy({
					left: 300, // Adjust scroll distance as needed
					behavior: 'smooth',
				})
			}
		},
	},
}
</script>
